var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
    This file is generated with the "identicons" script.
    To update this output make changes to `scripts/svgr/identicon-icon-template.js
    */
import * as React from 'react';
import { IdenticonsCustomProperty, useColorMap, identiconComponentName } from '../common';
import { styled } from '../../styled';
export var IdenticonRefreshToken = styled(function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    var colorMap = useColorMap({
        color: color,
    });
    var fills = {
        light: "var(".concat(IdenticonsCustomProperty.light, ", ").concat(colorMap.light, ")"),
        base: "var(".concat(IdenticonsCustomProperty.base, ", ").concat(colorMap.base, ")"),
        dark: "var(".concat(IdenticonsCustomProperty.dark, ", ").concat(colorMap.dark, ")"),
    };
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M28 41.876h5.107a4.262 4.262 0 004.054-2.945l5.63-17.328a4.26 4.26 0 00-1.547-4.764L26.504 6.132a4.262 4.262 0 00-5.01 0L6.756 16.839a4.262 4.262 0 00-1.547 4.764l5.63 17.328a4.262 4.262 0 004.054 2.945H19.3", stroke: fills.dark, strokeWidth: 3.5, strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M22.418 13.513L13.11 20.25a2.67 2.67 0 00-.977 2.996l3.556 10.902A2.689 2.689 0 0018.25 36h11.505a2.69 2.69 0 002.559-1.853l3.555-10.902a2.676 2.676 0 00-.976-2.997l-9.309-6.735a2.696 2.696 0 00-3.165 0z", fill: fills.base }),
        React.createElement("path", { d: "M27.541 44.751l-2.674-2.276c-.385-.327-.385-.86 0-1.188l2.674-2.276c.623-.528 1.686-.153 1.686.594v4.552c0 .75-1.063 1.125-1.686.594z", fill: fills.dark })));
}, {
    name: identiconComponentName,
})({});
